// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"316":"medium","429":"contactUs","443":"about","501":"public","577":"shopping","977":"commodity"}[chunkId] + "." + {"316":"99ac1f46","429":"5186874c","443":"379b7f2b","501":"19a7c47c","577":"240c103c","977":"646f7052"}[chunkId] + ".css";
};